// FKLN-427 — product page revamp
(function () {
  function collapsedText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function truncateHtml(html, visibleLength) {
    var source = document.createElement('div');
    source.innerHTML = html;
    var textNodes = [];
    var walker = document.createTreeWalker(source, NodeFilter.SHOW_TEXT);
    var current;
    while ((current = walker.nextNode())) textNodes.push(current);

    var raw = '';
    textNodes.forEach(function (node) {
      raw += node.nodeValue || '';
    });

    var collapsedToRaw = [];
    var pendingSpace = -1;
    for (var i = 0; i < raw.length; i++) {
      if (/\s/.test(raw.charAt(i))) {
        if (collapsedToRaw.length) pendingSpace = i;
      } else {
        if (pendingSpace >= 0) {
          collapsedToRaw.push(pendingSpace);
          pendingSpace = -1;
        }
        collapsedToRaw.push(i);
      }
    }

    if (visibleLength >= collapsedToRaw.length) return html;
    if (visibleLength <= 0) return '...';

    var endRaw = collapsedToRaw[visibleLength - 1] + 1;
    var dest = document.createElement('div');
    var rawPos = 0;
    var inlineTags = {
      A: 1, B: 1, EM: 1, I: 1, MARK: 1, SMALL: 1, SPAN: 1, STRONG: 1, SUB: 1, SUP: 1, U: 1
    };

    function cloneUntil(src, parent) {
      for (var c = 0; c < src.childNodes.length; c++) {
        var node = src.childNodes[c];
        if (node.nodeType === 3) {
          var value = node.nodeValue || '';
          var nodeStart = rawPos;
          rawPos += value.length;
          if (nodeStart >= endRaw) return true;
          var slice = value.slice(0, Math.min(value.length, endRaw - nodeStart));
          if (slice) parent.appendChild(document.createTextNode(slice));
          if (nodeStart + value.length >= endRaw) return true;
        } else if (node.nodeType === 1) {
          if (node.tagName === 'BR') continue;
          if (!inlineTags[node.tagName]) {
            if (cloneUntil(node, parent)) return true;
            continue;
          }
          var clone = node.cloneNode(false);
          parent.appendChild(clone);
          var stop = cloneUntil(node, clone);
          if (!clone.childNodes.length) parent.removeChild(clone);
          if (stop) return true;
        }
      }
      return false;
    }

    cloneUntil(source, dest);

    var lastText = null;
    var textWalker = document.createTreeWalker(dest, NodeFilter.SHOW_TEXT);
    var textNode;
    while ((textNode = textWalker.nextNode())) lastText = textNode;
    if (lastText) lastText.nodeValue = lastText.nodeValue.replace(/\s+$/, '');
    dest.appendChild(document.createTextNode('...'));
    return dest.innerHTML;
  }

  function initLirePlus() {
    var lineCount = 4;

    document.querySelectorAll('[data-product-lire-plus]').forEach(function (wrap) {
      var text = wrap.querySelector('[data-lire-plus-text]');
      var toggle = wrap.querySelector('[data-lire-plus-toggle]');
      if (!text || !toggle) return;

      var fullHTML = text.innerHTML;
      var fullText = collapsedText(text.textContent);
      var lineHeight = parseFloat(window.getComputedStyle(wrap).lineHeight) || 20;
      var maxHeight = lineHeight * lineCount + 1;

      function overflows() {
        return wrap.scrollHeight > maxHeight;
      }

      function showClipped(visibleLength) {
        text.innerHTML = truncateHtml(fullHTML, visibleLength);
      }

      function applyCollapse() {
        text.classList.add('is-collapsed');
        text.innerHTML = fullHTML;
        toggle.hidden = false;
        toggle.textContent = 'Lire plus';
        toggle.setAttribute('aria-expanded', 'false');

        if (!overflows()) {
          toggle.hidden = true;
          return;
        }

        var lo = 0;
        var hi = fullText.length;
        var best = 0;
        while (lo <= hi) {
          var mid = (lo + hi) >> 1;
          showClipped(mid);
          if (overflows()) {
            hi = mid - 1;
          } else {
            best = mid;
            lo = mid + 1;
          }
        }

        var clipped = fullText.slice(0, best).replace(/\s+$/, '');
        var lastSpace = clipped.lastIndexOf(' ');
        if (lastSpace > 24) clipped = clipped.slice(0, lastSpace);
        showClipped(clipped.length);

        while (overflows() && clipped.length) {
          clipped = clipped.slice(0, -1).replace(/\s+$/, '');
          showClipped(clipped.length);
        }
      }

      function applyExpand() {
        text.classList.remove('is-collapsed');
        text.innerHTML = fullHTML;
        toggle.hidden = false;
        toggle.textContent = 'Lire moins';
        toggle.setAttribute('aria-expanded', 'true');
      }

      requestAnimationFrame(applyCollapse);

      toggle.addEventListener('click', function () {
        var collapsing = !text.classList.contains('is-collapsed');
        if (collapsing) {
          applyCollapse();
        } else {
          applyExpand();
        }
        window.dispatchEvent(new CustomEvent('hb_navigation_click', {
          detail: {
            type: 'pdp_description',
            name: collapsing ? 'lire_moins' : 'lire_plus',
            click_text: toggle.textContent,
            click_link: '/'
          }
        }));
      });
    });
  }

  function initMarketingPushTracking() {
    document.querySelectorAll('[data-marketing-push]').forEach(function (el) {
      el.addEventListener('click', function () {
        var url = el.getAttribute('data-marketing-push-url') || el.getAttribute('href') || '/';
        window.dispatchEvent(new CustomEvent('hb_navigation_click', {
          detail: {
            type: 'pdp_marketing_push',
            name: 'marketing_push_click',
            click_text: 'marketing_push',
            click_link: url
          }
        }));
      });
    });
  }

  function applyUgcCtaSizes(root) {
    if (!root) return;
    var nodes = root.querySelectorAll('button, a, span');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.classList.contains('product-ugc__arrow')) continue;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === 'Publier un contenu') {
        el.style.display = 'none';
      } else if (text === 'Voir plus') {
        el.style.fontSize = '14px';
      }
    }
  }

  function stripFaqQuestionNumbers() {
    document.querySelectorAll('#section-faq .faq-group__question-container').forEach(function (el) {
      var text = (el.textContent || '').replace(/^\s*\d+[\.\)\-:]\s+/, '');
      if (text && text !== el.textContent) {
        el.textContent = text;
      }
    });
  }

  function countUgcPosts(flow) {
    if (!flow) return 0;
    var selectors = [
      '.bzfy-c-tilegrid-post',
      '.bzfy-t-feed-tile-grid > *',
      '.flb-post',
      '.flowbox-post',
      '.flb-feed__item',
      '.flb-card',
      '[data-post]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = flow.querySelectorAll(selectors[i]);
      if (nodes.length) return nodes.length;
    }
    return 0;
  }

  function syncUgcEmptyState(section, flow, ready) {
    var count = countUgcPosts(flow);
    var fallbacks = document.querySelectorAll('[data-reviews-ugc-fallback]');
    if (count > 0) {
      section.classList.remove('is-empty');
      section.removeAttribute('hidden');
      fallbacks.forEach(function (el) {
        el.setAttribute('hidden', '');
      });
      return;
    }
    if (!ready) return;
    section.classList.add('is-empty');
    section.setAttribute('hidden', '');
    fallbacks.forEach(function (el) {
      el.removeAttribute('hidden');
    });
  }

  function initUgcNav() {
    var ugcSections = document.querySelectorAll('[data-product-ugc]');
    if (!ugcSections.length) {
      document.querySelectorAll('[data-reviews-ugc-fallback]').forEach(function (el) {
        el.removeAttribute('hidden');
      });
      return;
    }

    if (window.productflowboxPromotions && typeof window.productflowboxPromotions.init === 'function') {
      window.productflowboxPromotions.init();
    }

    document.querySelectorAll('[data-product-ugc]').forEach(function (section) {
      var flow = section.querySelector('.product-ugc__flow') || section.querySelector('.product-flowbox-sections');
      if (!flow) return;

      applyUgcCtaSizes(section);
      var ctaObserver = new MutationObserver(function () {
        applyUgcCtaSizes(section);
        syncUgcEmptyState(section, flow, countUgcPosts(flow) > 0);
      });
      ctaObserver.observe(section, { childList: true, subtree: true });

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        var count = countUgcPosts(flow);
        syncUgcEmptyState(section, flow, count > 0 || attempts > 8);
        if (count > 0 || attempts > 20) {
          clearInterval(timer);
          syncUgcEmptyState(section, flow, true);
        }
      }, 500);

      flow.addEventListener('click', function (e) {
        var video = e.target.closest('video, .flb-video, [data-video], .bzfy-c-tilegrid-post');
        if (!video) return;
        window.dispatchEvent(new CustomEvent('hb_navigation_click', {
          detail: {
            type: 'pdp_ugc',
            name: 'ugc_video',
            click_text: 'ugc_video',
            click_link: '/'
          }
        }));
      });
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-product-ugc]').forEach(applyUgcCtaSizes);
    });
  }

  function initCrossSell() {
    document.querySelectorAll('[data-product-cross-sell]').forEach(function (root) {
      var track = root.querySelector('[data-cross-sell-track]');
      var prev = root.querySelector('[data-cross-sell-prev]');
      var next = root.querySelector('[data-cross-sell-next]');
      var nav = root.querySelector('[data-cross-sell-nav]');
      if (!track || track.getAttribute('data-cross-sell-ready')) return;

      var originals = Array.prototype.slice.call(track.querySelectorAll('[data-cross-sell-card]'));
      if (!originals.length) return;
      track.setAttribute('data-cross-sell-ready', 'true');

      if (originals.length < 2) {
        if (nav) nav.setAttribute('hidden', '');
        return;
      }

      originals.forEach(function (card) {
        var endClone = card.cloneNode(true);
        endClone.setAttribute('data-cross-sell-clone', 'end');
        endClone.setAttribute('tabindex', '-1');
        endClone.setAttribute('aria-hidden', 'true');
        track.appendChild(endClone);
      });
      originals.slice().reverse().forEach(function (card) {
        var startClone = card.cloneNode(true);
        startClone.setAttribute('data-cross-sell-clone', 'start');
        startClone.setAttribute('tabindex', '-1');
        startClone.setAttribute('aria-hidden', 'true');
        track.insertBefore(startClone, track.firstChild);
      });

      var jumping = false;

      function setWidth() {
        var firstClone = track.querySelector('[data-cross-sell-clone="start"]');
        if (firstClone) return originals[0].offsetLeft - firstClone.offsetLeft;
        return originals[0].offsetLeft;
      }

      function cardStep() {
        if (originals[1]) return originals[1].offsetLeft - originals[0].offsetLeft;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 12;
        return originals[0].getBoundingClientRect().width + gap;
      }

      function jump(to) {
        jumping = true;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = to;
        requestAnimationFrame(function () {
          track.style.scrollSnapType = '';
          jumping = false;
        });
      }

      function normalize() {
        if (jumping) return;
        var w = setWidth();
        if (w <= 0) return;
        var x = track.scrollLeft;
        if (x < w) jump(x + w);
        else if (x >= w * 2) jump(x - w);
      }

      function goToOriginals() {
        jump(setWidth());
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(goToOriginals);
      });

      var scrollTimer;
      track.addEventListener('scroll', function () {
        if (jumping) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(normalize, 140);
      }, { passive: true });
      track.addEventListener('scrollend', normalize);

      function scrollByDir(dir) {
        track.scrollBy({ left: cardStep() * dir, behavior: 'smooth' });
        setTimeout(normalize, 420);
        window.dispatchEvent(new CustomEvent('hb_navigation_click', {
          detail: {
            type: 'pdp_cross_sell',
            name: dir < 0 ? 'cross_sell_prev' : 'cross_sell_next',
            click_text: 'cross_sell_arrow',
            click_link: '/'
          }
        }));
      }

      if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
      if (next) next.addEventListener('click', function () { scrollByDir(1); });

      track.addEventListener('click', function (e) {
        var card = e.target.closest('[data-cross-sell-card]');
        if (!card) return;
        window.dispatchEvent(new CustomEvent('hb_navigation_click', {
          detail: {
            type: 'pdp_cross_sell',
            name: 'cross_sell_product_click',
            click_text: card.getAttribute('data-product-name') || 'cross_sell_product',
            click_link: card.getAttribute('href') || '/'
          }
        }));
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(goToOriginals, 150);
      });
    });

    document.querySelectorAll('.product-suggestions [data-add-to-cart], .product-suggestions .product-card__button, .product-suggestions button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.dispatchEvent(new CustomEvent('hb_navigation_click', {
          detail: {
            type: 'pdp_cross_sell',
            name: 'cross_sell_add_to_cart',
            click_text: btn.textContent.trim() || 'cross_sell_atc',
            click_link: '/'
          }
        }));
      });
    });
  }

  function formatPrice(value) {
    if (!value && value !== 0) return '';
    return String(value).replace('.', ',') + '€';
  }

  function syncFormatPrices(isSubscription) {
    document.querySelectorAll('[data-pdp-revamp] [data-format-price]').forEach(function (card) {
      var main = card.querySelector('[data-format-price-main]');
      var secondary = card.querySelector('[data-format-price-secondary]');
      if (!main) return;

      var otp = card.getAttribute('data-price-otp');
      var sub = card.getAttribute('data-price-sub');
      var compare = card.getAttribute('data-price-compare');
      var unit = card.getAttribute('data-price-unit');

      if (isSubscription) {
        main.textContent = formatPrice(sub || otp);
        if (secondary) {
          secondary.textContent = formatPrice(otp);
          secondary.classList.remove('variant-compare--unit');
          secondary.hidden = false;
        }
      } else {
        main.textContent = formatPrice(otp);
        if (secondary) {
          if (compare) {
            secondary.textContent = formatPrice(compare);
            secondary.classList.remove('variant-compare--unit');
            secondary.hidden = false;
          } else if (unit) {
            secondary.textContent = unit;
            secondary.classList.add('variant-compare--unit');
            secondary.hidden = false;
          } else {
            secondary.textContent = '';
            secondary.hidden = true;
          }
        }
      }
    });
  }

  function syncSubscriptionDetails(isSubscription) {
    document.querySelectorAll('[data-pdp-revamp] .product__buy-options--subscription').forEach(function (block) {
      block.classList.toggle('is-selected', isSubscription);
    });
  }

  function getSelectedPurchaseOption() {
    var checked = document.querySelector('#product-buy-section input[name="buy-options"]:checked');
    return checked && checked.value === 'subscription';
  }

  function syncPurchasePrices() {
    var isSubscription = getSelectedPurchaseOption();
    syncFormatPrices(isSubscription);
    syncSubscriptionDetails(isSubscription);
    syncCalculateurSubscribeCta();
  }

  function syncCalculateurSubscribeCta() {
    document.querySelectorAll('[data-calculateur-revamp-subscribe]').forEach(function (btn) {
      btn.hidden = false;
      btn.removeAttribute('hidden');
    });
  }

  function syncAtcComparePrice() {
    document.querySelectorAll('[data-pdp-revamp] .product__only-one-time .product-add-to-cart .inline-price .product-old-price').forEach(function (el) {
      var inner = el.querySelector('[data-oneshot-quantity-price-rrp]');
      var val = inner ? String(inner.textContent || '').replace(/[^\d.,]/g, '').trim() : '';
      if (val) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  /* FKLN-474: keep one-time compare price + beige discount badge in sync with variant/qty */
  function parseEuroAmount(text) {
    var n = parseFloat(String(text || '').replace(/\s/g, '').replace(',', '.').replace(/[^\d.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function syncOnetimeCompareDiscount() {
    var root = document.querySelector('[data-pdp-revamp] .product__buy-options--one-time');
    if (!root) return;

    var compareEl = root.querySelector('.compare-price');
    var rrpEl = root.querySelector('[data-oneshot-quantity-price-rrp]');
    var priceEl = root.querySelector('[data-oneshot-quantity-price]');
    var badgeEl = root.querySelector('[data-onetime-discount-badge]');
    var rrpVal = rrpEl ? String(rrpEl.textContent || '').replace(/[^\d.,]/g, '').trim() : '';
    var hasRrp = !!rrpVal;

    if (compareEl) {
      if (hasRrp) compareEl.removeAttribute('hidden');
      else compareEl.setAttribute('hidden', '');
    }

    if (!badgeEl) return;
    if (!hasRrp) {
      badgeEl.hidden = true;
      return;
    }
    var rrp = parseEuroAmount(rrpVal);
    var price = parseEuroAmount(priceEl && priceEl.textContent);
    if (!(rrp > price) || rrp <= 0) {
      badgeEl.hidden = true;
      return;
    }
    var pct = Math.round(((rrp - price) / rrp) * 100);
    badgeEl.hidden = false;
    badgeEl.textContent = '-' + pct + '%';
  }

  function initAtcComparePrice() {
    var hasOnetimeOnly = !!document.querySelector('[data-pdp-revamp] .product__only-one-time');
    var hasOnetimeOption = !!document.querySelector('[data-pdp-revamp] .product__buy-options--one-time');
    if (!hasOnetimeOnly && !hasOnetimeOption) return;

    syncAtcComparePrice();
    syncOnetimeCompareDiscount();

    var observer = new MutationObserver(function () {
      syncAtcComparePrice();
      syncOnetimeCompareDiscount();
    });
    document.querySelectorAll('[data-pdp-revamp] [data-oneshot-quantity-price-rrp], [data-pdp-revamp] [data-oneshot-unit-price-rrp], [data-pdp-revamp] .product__buy-options--one-time [data-oneshot-quantity-price]').forEach(function (el) {
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function clearFrequencyError() {
    document.querySelectorAll('[data-pdp-revamp] .product-subscription-frequence.is-error, [data-pdp-revamp] .frequency-selector.is-error').forEach(function (el) {
      el.classList.remove('is-error');
    });
  }

  function initFrequencyValidation() {
    document.querySelectorAll('[data-pdp-revamp] #frequence, [data-pdp-revamp] [data-frequency-selector]').forEach(function (select) {
      select.addEventListener('change', function () {
        clearFrequencyError();
        window.dispatchEvent(new CustomEvent('hb_navigation_click', {
          detail: {
            type: 'pdp_purchase_option',
            name: 'frequency_change',
            click_text: select.value || 'frequency',
            click_link: '/'
          }
        }));
      });
    });
  }

  function initPurchaseOptionTracking() {
    document.querySelectorAll('#product-buy-section input[name="buy-options"]').forEach(function (input) {
      input.addEventListener('change', function () {
        syncPurchasePrices();
        if (input.value !== 'subscription') clearFrequencyError();
        window.dispatchEvent(new CustomEvent('hb_navigation_click', {
          detail: {
            type: 'pdp_purchase_option',
            name: 'view_subscription_choice',
            click_text: input.value,
            click_link: '/'
          }
        }));
      });
    });
    syncPurchasePrices();
  }

  function initCompositionAccordion() {
    document.querySelectorAll('[data-composition-accordion]').forEach(function (root) {
      var items = root.querySelectorAll('.product-composition-accordion__item');
      items.forEach(function (item) {
        var trigger = item.querySelector('[data-composition-trigger]');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          item.classList.toggle('is-open', willOpen);
          trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

          if (willOpen) {
            window.dispatchEvent(new CustomEvent('hb_navigation_click', {
              detail: {
                type: 'pdp_drawer',
                name: 'drawer_open',
                click_text: trigger.getAttribute('data-drawer-label') || trigger.textContent.trim(),
                click_link: '/'
              }
            }));
          }
        });
      });
    });
  }

  function initIngredientsBenefits() {
    document.querySelectorAll('[data-ingredients-benefits]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-ingredients-slide]');
      var prev = root.querySelector('[data-ingredients-prev]');
      var next = root.querySelector('[data-ingredients-next]');
      var counter = root.querySelector('[data-ingredients-counter]');
      if (!slides.length) return;

      var index = 0;
      var total = slides.length;

      function goTo(nextIndex, dir) {
        if (total < 1) return;
        index = ((nextIndex % total) + total) % total;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('hidden');
          } else {
            slide.setAttribute('hidden', '');
          }
        });
        if (counter) counter.textContent = (index + 1) + '/' + total;
        if (typeof dir === 'number') {
          window.dispatchEvent(new CustomEvent('hb_navigation_click', {
            detail: {
              type: 'pdp_ingredients_benefits',
              name: dir < 0 ? 'ingredients_prev' : 'ingredients_next',
              click_text: 'ingredients_arrow',
              click_link: '/'
            }
          }));
        }
      }

      if (prev) {
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(index - 1, -1);
        });
      }
      if (next) {
        next.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(index + 1, 1);
        });
      }

      goTo(0);
    });
  }

  function initGalleryVideos() {
    document.querySelectorAll('[data-pdp-revamp] .product__slide.is-video').forEach(function (slide) {
      var wrap = slide.querySelector('.has-video');
      var video = slide.querySelector('video');
      if (!wrap || !video) return;

      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('controls', '');
      video.controls = true;

      // Keep native controls visible; don't rely on the theme overlay state
      wrap.classList.remove('not-playing');

      video.addEventListener('play', function () {
        wrap.classList.remove('not-playing');
      });

      video.addEventListener('pause', function () {
        wrap.classList.remove('not-playing');
      });

      video.addEventListener('ended', function () {
        wrap.classList.remove('not-playing');
        try { video.currentTime = 0; } catch (err) {}
      });
    });
  }

  function initProblematiqueAccordion() {
    document.querySelectorAll('[data-product-problematique]').forEach(function (root) {
      var items = root.querySelectorAll('.product-problematique__item');
      items.forEach(function (item) {
        var trigger = item.querySelector('[data-problematique-trigger]');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          item.classList.toggle('is-open', willOpen);
          trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

          if (willOpen) {
            var label = item.querySelector('.product-problematique__label');
            window.dispatchEvent(new CustomEvent('hb_navigation_click', {
              detail: {
                type: 'pdp_problematique',
                name: 'problematique_open',
                click_text: label ? label.textContent.trim() : 'problematique',
                click_link: '/'
              }
            }));
          }
        });
      });
    });
  }

  function youtubeIdFromUrl(url) {
    if (!url) return '';
    var match = String(url).match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{11})/);
    return match ? match[1] : '';
  }

  function vimeoIdFromUrl(url) {
    if (!url) return '';
    var match = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match ? match[1] : '';
  }

  var recipeVideoLightboxState = {
    card: null,
    cards: [],
    tapCandidate: false,
    pipActive: false
  };

  function getRecipeVideoLightbox() {
    var lightbox = document.querySelector('[data-recipe-video-lightbox]');
    if (lightbox && !lightbox.querySelector('[data-recipe-video-lightbox-fullscreen]')) {
      lightbox.remove();
      lightbox = null;
    }
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'product-recipe-videos-lightbox';
    lightbox.setAttribute('data-recipe-video-lightbox', '');
    lightbox.setAttribute('hidden', '');
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Vidéo');
    lightbox.innerHTML =
      '<div class="product-recipe-videos-lightbox__dialog">' +
        '<button type="button" class="product-recipe-videos-lightbox__close" data-recipe-video-lightbox-close aria-label="Fermer">' +
          '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
            '<path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
        '<button type="button" class="product-recipe-videos-lightbox__fullscreen" data-recipe-video-lightbox-fullscreen aria-label="Plein écran">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
            '<path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</button>' +
        '<button type="button" class="product-recipe-videos-lightbox__play-toggle" data-recipe-video-lightbox-play-toggle hidden aria-label="Lecture">' +
          '<svg width="28" height="28" viewBox="0 0 26 26" fill="none" aria-hidden="true">' +
            '<circle cx="13" cy="13" r="12" stroke="white" stroke-width="1.5"/>' +
            '<path d="M17.5 13L10.5 17.5V8.5L17.5 13Z" fill="white"/>' +
          '</svg>' +
        '</button>' +
        '<video class="product-recipe-videos-lightbox__media" data-recipe-video-lightbox-player playsinline webkit-playsinline></video>' +
        '<iframe class="product-recipe-videos-lightbox__media" data-recipe-video-lightbox-iframe hidden title="Vidéo" allow="autoplay; fullscreen" allowfullscreen></iframe>' +
      '</div>';
    document.body.appendChild(lightbox);
    return lightbox;
  }

  function resetRecipeVideoLightboxChrome(lightbox) {
    var dialog = lightbox && lightbox.querySelector('.product-recipe-videos-lightbox__dialog');
    if (dialog) {
      dialog.style.transform = '';
      dialog.style.transition = '';
      dialog.style.aspectRatio = '';
      dialog.style.width = '';
      dialog.style.height = '';
      dialog.classList.remove('is-paused');
      dialog.style.removeProperty('--recipe-video-ar');
    }
    if (lightbox) {
      lightbox.style.opacity = '';
      lightbox.style.removeProperty('--recipe-video-ar');
    }
  }

  function fitRecipeVideoLightboxToMedia(lightbox, player) {
    var dialog = lightbox && lightbox.querySelector('.product-recipe-videos-lightbox__dialog');
    if (!dialog || !player) return;
    var w = player.videoWidth;
    var h = player.videoHeight;
    if (!w || !h) return;

    var ratio = w / h;
    var gutter = window.matchMedia('(max-width: 800px)').matches ? 60 : 0;
    dialog.style.setProperty('--recipe-video-ar', String(ratio));
    dialog.style.aspectRatio = w + ' / ' + h;

    var maxW = Math.max(0, window.innerWidth - gutter);
    var maxH = Math.max(0, window.innerHeight - gutter);
    if (ratio >= maxW / maxH) {
      dialog.style.width = maxW + 'px';
      dialog.style.height = (maxW / ratio) + 'px';
    } else {
      dialog.style.height = maxH + 'px';
      dialog.style.width = (maxH * ratio) + 'px';
    }
  }

  function syncRecipeVideoPlayUi(lightbox) {
    var player = lightbox && lightbox.querySelector('[data-recipe-video-lightbox-player]');
    var dialog = lightbox && lightbox.querySelector('.product-recipe-videos-lightbox__dialog');
    var playToggle = lightbox && lightbox.querySelector('[data-recipe-video-lightbox-play-toggle]');
    if (!player || !dialog) return;
    var paused = player.paused;
    dialog.classList.toggle('is-paused', paused);
    if (playToggle) {
      playToggle.hidden = !paused || player.hidden;
      playToggle.setAttribute('aria-label', paused ? 'Lecture' : 'Pause');
    }
  }

  function toggleRecipeVideoPlayback() {
    var lightbox = document.querySelector('[data-recipe-video-lightbox]');
    var player = lightbox && lightbox.querySelector('[data-recipe-video-lightbox-player]');
    if (!player || player.hidden || lightbox.hasAttribute('hidden')) return;
    if (player.paused) {
      var playPromise = player.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    } else {
      player.pause();
    }
    syncRecipeVideoPlayUi(lightbox);
  }

  function enterRecipeVideoFullscreen(player, options) {
    if (!player) return;
    options = options || {};
    var onFail = typeof options.onFail === 'function' ? options.onFail : null;
    var onExit = typeof options.onExit === 'function' ? options.onExit : null;
    player.setAttribute('controls', '');
    player.controls = true;

    var fail = function () {
      if (onFail) onFail();
      else if (options.closeOnExit) closeRecipeVideoLightbox();
      else {
        player.removeAttribute('controls');
        player.controls = false;
      }
    };

    var done = function () {
      if (isRecipeVideoInPip(player)) {
        if (onExit) onExit('pip');
        else releaseRecipeVideoLightboxForPip();
        return;
      }
      if (onExit) {
        onExit('close');
        return;
      }
      if (options.closeOnExit) {
        closeRecipeVideoLightbox();
        return;
      }
      player.removeAttribute('controls');
      player.controls = false;
      syncRecipeVideoPlayUi(document.querySelector('[data-recipe-video-lightbox]'));
    };

    var entered = false;
    var attempting = false;
    var tryEnter = function () {
      if (entered || attempting) return;
      attempting = true;

      if (typeof player.webkitEnterFullscreen === 'function') {
        var onEnd = function () {
          player.removeEventListener('webkitendfullscreen', onEnd);
          done();
        };
        player.addEventListener('webkitendfullscreen', onEnd);
        try {
          player.webkitEnterFullscreen();
        } catch (err) {
          attempting = false;
          player.removeEventListener('webkitendfullscreen', onEnd);
          fail();
          return;
        }
        // iOS can no-op without throwing — verify we actually entered
        window.setTimeout(function () {
          var mode = player.webkitPresentationMode;
          if (mode === 'fullscreen' || mode === 'picture-in-picture') {
            entered = true;
            player.setAttribute('data-was-native-fs', 'true');
            return;
          }
          attempting = false;
          player.removeEventListener('webkitendfullscreen', onEnd);
          fail();
        }, 450);
        return;
      }

      if (typeof player.requestFullscreen === 'function') {
        var promise = player.requestFullscreen();
        if (promise && typeof promise.then === 'function') {
          promise.then(function () {
            entered = true;
            player.setAttribute('data-was-native-fs', 'true');
            var onFsChange = function () {
              if (!document.fullscreenElement) {
                document.removeEventListener('fullscreenchange', onFsChange);
                done();
              }
            };
            document.addEventListener('fullscreenchange', onFsChange);
          }).catch(function () {
            attempting = false;
            fail();
          });
          return;
        }
      }

      attempting = false;
      fail();
    };

    // iOS needs metadata / a playing video before webkitEnterFullscreen works
    var armReady = function () {
      if (entered || attempting) return;
      if (player.readyState >= 1) tryEnter();
    };
    if (player.readyState >= 1) {
      tryEnter();
    } else {
      player.addEventListener('loadedmetadata', armReady, { once: true });
      player.addEventListener('loadeddata', armReady, { once: true });
      player.addEventListener('canplay', armReady, { once: true });
    }
  }

  function bindInlineRecipeVideoNativeFs(player) {
    if (!player || player.getAttribute('data-inline-fs-bound')) return;
    player.setAttribute('data-inline-fs-bound', 'true');

    var resetInline = function () {
      if (isRecipeVideoInPip(player)) return;
      player.pause();
      player.removeAttribute('controls');
      player.controls = false;
      try { player.currentTime = 0; } catch (err) {}
      var card = player.closest('[data-recipe-video-card]');
      if (card) card.classList.remove('is-playing');
    };

    player.addEventListener('webkitendfullscreen', resetInline);
    document.addEventListener('fullscreenchange', function () {
      if (document.fullscreenElement === player) return;
      if (document.fullscreenElement) return;
      // Only reset if this player was the one in FS / just left FS
      if (player.getAttribute('data-was-native-fs') === 'true') {
        player.removeAttribute('data-was-native-fs');
        resetInline();
      }
    });
    player.addEventListener('enterpictureinpicture', function () {
      var card = player.closest('[data-recipe-video-card]');
      if (card) card.classList.remove('is-playing');
    });
    player.addEventListener('leavepictureinpicture', resetInline);
    player.addEventListener('webkitpresentationmodechanged', function () {
      if (player.webkitPresentationMode === 'fullscreen') {
        player.setAttribute('data-was-native-fs', 'true');
      } else if (player.webkitPresentationMode === 'picture-in-picture') {
        player.removeAttribute('data-was-native-fs');
        var card = player.closest('[data-recipe-video-card]');
        if (card) card.classList.remove('is-playing');
      } else if (player.webkitPresentationMode === 'inline') {
        resetInline();
      }
    });
  }

  function openRecipeVideoNativeFromCard(card) {
    var player = card.querySelector('[data-recipe-video-player]');
    var videoSrc = card.getAttribute('data-video-src');
    if (!player || !videoSrc) return false;

    bindInlineRecipeVideoNativeFs(player);
    card.classList.add('is-playing');
    player.setAttribute('playsinline', '');
    player.setAttribute('webkit-playsinline', '');
    player.setAttribute('preload', 'auto');
    if (!player.getAttribute('src')) player.setAttribute('src', videoSrc);
    player.setAttribute('controls', '');
    player.controls = true;
    player.muted = false;

    var startFs = function () {
      enterRecipeVideoFullscreen(player, {
        onFail: function () {
          // Native FS unavailable — fall back to the custom lightbox
          card.classList.remove('is-playing');
          player.pause();
          player.removeAttribute('controls');
          player.controls = false;
          openRecipeVideoLightbox(card, { forceLightbox: true });
        },
        onExit: function (reason) {
          if (reason === 'pip') return;
          player.pause();
          player.removeAttribute('controls');
          player.controls = false;
          try { player.currentTime = 0; } catch (err) {}
          card.classList.remove('is-playing');
        }
      });
    };

    var playPromise = player.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(startFs).catch(function () {
        player.muted = true;
        return player.play().then(startFs);
      }).catch(function () {
        startFs();
      });
    } else {
      startFs();
    }
    return true;
  }

  function isRecipeVideoInPip(player) {
    if (!player) return false;
    if (document.pictureInPictureElement === player) return true;
    if (player.webkitPresentationMode === 'picture-in-picture') return true;
    return false;
  }

  function stageRecipeVideoOffscreen(lightbox) {
    if (!lightbox) return;
    lightbox.classList.add('is-direct-fs');
    lightbox.classList.remove('is-pip');
    lightbox.removeAttribute('hidden');
    document.body.classList.remove('is-recipe-video-lightbox');
  }

  // Hide our modal so the page is usable, but keep the <video> alive for iOS PiP
  function releaseRecipeVideoLightboxForPip() {
    var lightbox = document.querySelector('[data-recipe-video-lightbox]');
    if (!lightbox) return;
    var player = lightbox.querySelector('[data-recipe-video-lightbox-player]');

    recipeVideoLightboxState.pipActive = true;
    lightbox.classList.add('is-pip');
    lightbox.classList.remove('is-direct-fs');
    lightbox.removeAttribute('hidden');
    resetRecipeVideoLightboxChrome(lightbox);
    document.body.classList.remove('is-recipe-video-lightbox');

    if (player) {
      player.removeAttribute('controls');
      player.controls = false;
      if (player.paused) {
        var playPromise = player.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
    }
  }

  function closeRecipeVideoLightbox() {
    var lightbox = document.querySelector('[data-recipe-video-lightbox]');
    if (!lightbox) return;
    var isStaged = lightbox.classList.contains('is-pip') || lightbox.classList.contains('is-direct-fs');
    if (lightbox.hasAttribute('hidden') && !isStaged) return;

    var player = lightbox.querySelector('[data-recipe-video-lightbox-player]');
    var iframe = lightbox.querySelector('[data-recipe-video-lightbox-iframe]');
    var fsBtn = lightbox.querySelector('[data-recipe-video-lightbox-fullscreen]');
    var playToggle = lightbox.querySelector('[data-recipe-video-lightbox-play-toggle]');

    // Don't kill the media while native PiP is still running
    if (isRecipeVideoInPip(player)) {
      releaseRecipeVideoLightboxForPip();
      return;
    }

    if (player) {
      player.pause();
      player.removeAttribute('controls');
      player.controls = false;
      player.removeAttribute('src');
      player.load();
    }
    if (iframe) {
      iframe.hidden = true;
      iframe.removeAttribute('src');
    }
    if (player) player.hidden = false;
    if (fsBtn) fsBtn.hidden = false;
    if (playToggle) playToggle.hidden = true;
    resetRecipeVideoLightboxChrome(lightbox);
    lightbox.classList.remove('is-pip');
    lightbox.classList.remove('is-direct-fs');
    lightbox.setAttribute('hidden', '');
    document.body.classList.remove('is-recipe-video-lightbox');
    recipeVideoLightboxState.card = null;
    recipeVideoLightboxState.cards = [];
    recipeVideoLightboxState.pipActive = false;
  }

  function cleanupRecipeVideoAfterPip() {
    var lightbox = document.querySelector('[data-recipe-video-lightbox]');
    var player = lightbox && lightbox.querySelector('[data-recipe-video-lightbox-player]');
    recipeVideoLightboxState.pipActive = false;
    if (lightbox) {
      lightbox.classList.remove('is-pip');
      lightbox.classList.remove('is-direct-fs');
    }
    if (player && isRecipeVideoInPip(player)) return;
    closeRecipeVideoLightbox();
  }

  function getNextRecipeVideoCard() {
    var cards = recipeVideoLightboxState.cards;
    var current = recipeVideoLightboxState.card;
    if (!cards.length || !current) return null;
    var idx = cards.indexOf(current);
    if (idx < 0 || idx >= cards.length - 1) return null;
    return cards[idx + 1];
  }

  function getPrevRecipeVideoCard() {
    var cards = recipeVideoLightboxState.cards;
    var current = recipeVideoLightboxState.card;
    if (!cards.length || !current) return null;
    var idx = cards.indexOf(current);
    if (idx <= 0) return null;
    return cards[idx - 1];
  }

  function goToRecipeVideoCard(card, direction) {
    var lightbox = document.querySelector('[data-recipe-video-lightbox]');
    var dialog = lightbox && lightbox.querySelector('.product-recipe-videos-lightbox__dialog');
    if (dialog) {
      dialog.style.transition = 'transform 180ms ease-out';
      dialog.style.transform = direction < 0 ? 'translateX(-110%)' : 'translateX(110%)';
    }
    if (lightbox) lightbox.style.opacity = '0';
    window.setTimeout(function () {
      openRecipeVideoLightbox(card);
    }, 160);
  }

  function bindRecipeVideoLightboxSwipe(lightbox) {
    var dialog = lightbox.querySelector('.product-recipe-videos-lightbox__dialog');
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var dy = 0;
    var tracking = false;
    var axis = null;

    lightbox.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      if (e.target.closest('button')) { tracking = false; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0;
      dy = 0;
      axis = null;
      tracking = true;
      recipeVideoLightboxState.tapCandidate = true;
      if (dialog) dialog.style.transition = 'none';
    }, { passive: true });

    lightbox.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      dx = e.touches[0].clientX - startX;
      dy = e.touches[0].clientY - startY;
      if (!dialog) return;

      if (!axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dy) >= Math.abs(dx) ? 'y' : 'x';
        recipeVideoLightboxState.tapCandidate = false;
      }

      if (axis === 'y') {
        dialog.style.transform = 'translateY(' + dy + 'px)';
        lightbox.style.opacity = String(Math.max(0, 1 - Math.abs(dy) / 280));
        return;
      }

      var hasNeighbor = dx < 0 ? !!getNextRecipeVideoCard() : !!getPrevRecipeVideoCard();
      var pull = hasNeighbor ? dx : dx * 0.25;
      dialog.style.transform = 'translateX(' + pull + 'px)';
      lightbox.style.opacity = hasNeighbor
        ? String(Math.max(0.35, 1 - Math.abs(dx) / 420))
        : String(Math.max(0.55, 1 - Math.abs(dx) / 480));
    }, { passive: true });

    lightbox.addEventListener('touchend', function () {
      if (!tracking) return;
      tracking = false;
      var wasTap = recipeVideoLightboxState.tapCandidate && Math.abs(dx) < 10 && Math.abs(dy) < 10;
      recipeVideoLightboxState.tapCandidate = false;

      if (wasTap) {
        toggleRecipeVideoPlayback();
        return;
      }

      var vertical = axis === 'y' && Math.abs(dy) > 80;
      var right = axis === 'x' && dx > 80;
      var left = axis === 'x' && dx < -80;
      var nextCard = left ? getNextRecipeVideoCard() : null;
      var prevCard = right ? getPrevRecipeVideoCard() : null;

      if (vertical) {
        closeRecipeVideoLightbox();
        return;
      }

      if (nextCard) {
        goToRecipeVideoCard(nextCard, -1);
        return;
      }

      if (prevCard) {
        goToRecipeVideoCard(prevCard, 1);
        return;
      }

      if (dialog) {
        dialog.style.transition = 'transform 180ms ease-out';
        dialog.style.transform = '';
      }
      lightbox.style.opacity = '';
    });
  }

  function bindRecipeVideoLightboxControls(lightbox) {
    var player = lightbox.querySelector('[data-recipe-video-lightbox-player]');
    var fsBtn = lightbox.querySelector('[data-recipe-video-lightbox-fullscreen]');
    var playToggle = lightbox.querySelector('[data-recipe-video-lightbox-play-toggle]');
    var closeBtn = lightbox.querySelector('[data-recipe-video-lightbox-close]');

    if (player) {
      player.addEventListener('play', function () { syncRecipeVideoPlayUi(lightbox); });
      player.addEventListener('pause', function () { syncRecipeVideoPlayUi(lightbox); });
      player.addEventListener('click', function (e) {
        // Only custom tap-to-pause when native controls are off (not desktop lightbox)
        if (player.controls) return;
        if (window.matchMedia('(hover: hover)').matches) {
          e.preventDefault();
          toggleRecipeVideoPlayback();
        }
      });
      player.addEventListener('enterpictureinpicture', function () {
        releaseRecipeVideoLightboxForPip();
      });
      player.addEventListener('leavepictureinpicture', function () {
        cleanupRecipeVideoAfterPip();
      });
      player.addEventListener('webkitpresentationmodechanged', function () {
        if (player.webkitPresentationMode === 'picture-in-picture') {
          releaseRecipeVideoLightboxForPip();
        } else if (
          recipeVideoLightboxState.pipActive &&
          player.webkitPresentationMode === 'inline'
        ) {
          cleanupRecipeVideoAfterPip();
        }
      });
    }

    if (playToggle) {
      playToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleRecipeVideoPlayback();
      });
    }

    if (fsBtn) {
      fsBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        enterRecipeVideoFullscreen(player);
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeRecipeVideoLightbox);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeRecipeVideoLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeRecipeVideoLightbox();
      if (e.key === ' ' && !lightbox.hasAttribute('hidden')) {
        var tag = (e.target && e.target.tagName) || '';
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'BUTTON') return;
        e.preventDefault();
        toggleRecipeVideoPlayback();
      }
    });
  }

  function openRecipeVideoLightbox(card, options) {
    options = options || {};
    var videoSrc = card.getAttribute('data-video-src');
    var videoUrl = card.getAttribute('data-video-url');
    var caption = card.getAttribute('data-video-caption') || 'Vidéo';
    var youtubeId = youtubeIdFromUrl(videoUrl);
    var vimeoId = vimeoIdFromUrl(videoUrl);
    var isMobile = window.matchMedia('(max-width: 800px)').matches;

    // Mobile hosted videos: play the card <video> directly in native fullscreen
    if (isMobile && videoSrc && !options.forceLightbox) {
      if (openRecipeVideoNativeFromCard(card)) return;
    }

    var lightbox = getRecipeVideoLightbox();
    var player = lightbox.querySelector('[data-recipe-video-lightbox-player]');
    var iframe = lightbox.querySelector('[data-recipe-video-lightbox-iframe]');
    var fsBtn = lightbox.querySelector('[data-recipe-video-lightbox-fullscreen]');
    var playToggle = lightbox.querySelector('[data-recipe-video-lightbox-play-toggle]');
    var root = card.closest('[data-product-recipe-videos]');

    recipeVideoLightboxState.card = card;
    recipeVideoLightboxState.cards = root
      ? Array.prototype.slice.call(root.querySelectorAll('[data-recipe-video-card]'))
      : [card];

    lightbox.setAttribute('aria-label', caption);
    resetRecipeVideoLightboxChrome(lightbox);
    lightbox.classList.remove('is-pip');
    lightbox.classList.remove('is-direct-fs');
    recipeVideoLightboxState.pipActive = false;

    if (videoSrc && player) {
      if (iframe) {
        iframe.hidden = true;
        iframe.removeAttribute('src');
      }
      player.hidden = false;
      player.setAttribute('playsinline', '');
      player.setAttribute('webkit-playsinline', '');
      player.src = videoSrc;
      player.muted = false;

      // Desktop keeps the original lightbox + native controls (mobile uses native FS above)
      player.setAttribute('controls', '');
      player.controls = true;
      if (fsBtn) fsBtn.hidden = true;
      if (playToggle) playToggle.hidden = true;
      lightbox.classList.remove('is-direct-fs');
      lightbox.removeAttribute('hidden');
      document.body.classList.add('is-recipe-video-lightbox');

      var applySize = function () {
        fitRecipeVideoLightboxToMedia(lightbox, player);
      };
      if (player.videoWidth) {
        applySize();
      } else {
        player.addEventListener('loadedmetadata', applySize, { once: true });
      }

      var desktopPlay = player.play();
      if (desktopPlay && typeof desktopPlay.catch === 'function') {
        desktopPlay.catch(function () {
          player.muted = true;
          player.play().catch(function () {});
        });
      }
    } else if ((youtubeId || vimeoId) && iframe) {
      if (player) {
        player.pause();
        player.hidden = true;
        player.removeAttribute('src');
      }
      if (fsBtn) fsBtn.hidden = true;
      if (playToggle) playToggle.hidden = true;
      iframe.hidden = false;
      iframe.src = youtubeId
        ? 'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&rel=0&playsinline=1'
        : 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1';
      lightbox.removeAttribute('hidden');
      document.body.classList.add('is-recipe-video-lightbox');
    } else if (videoUrl) {
      window.open(videoUrl, '_blank', 'noopener');
      return;
    } else {
      return;
    }

    if (!lightbox.getAttribute('data-bound')) {
      lightbox.setAttribute('data-bound', 'true');
      bindRecipeVideoLightboxControls(lightbox);
      bindRecipeVideoLightboxSwipe(lightbox);
    }
  }

  function initRecipeVideos() {
    document.querySelectorAll('[data-product-recipe-videos]').forEach(function (root) {
      var track = root.querySelector('[data-recipe-videos-track]');
      var prev = root.querySelector('[data-recipe-videos-prev]');
      var next = root.querySelector('[data-recipe-videos-next]');
      var isSlider = root.classList.contains('product-recipe-videos--slider');
      if (!track) return;

      if (isSlider) {
        function scrollByDir(dir) {
          var card = track.querySelector('.product-recipe-videos__card:not(.product-recipe-videos__card--spacer)');
          var cardWidth = card ? card.getBoundingClientRect().width : 172;
          var amount = (cardWidth + 15) * dir;
          track.scrollBy({ left: amount, behavior: 'smooth' });
          window.dispatchEvent(new CustomEvent('hb_navigation_click', {
            detail: {
              type: 'pdp_recipe_videos',
              name: dir < 0 ? 'recipe_videos_prev' : 'recipe_videos_next',
              click_text: 'recipe_videos_arrow',
              click_link: '/'
            }
          }));
        }

        if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
        if (next) next.addEventListener('click', function () { scrollByDir(1); });
      }

      root.querySelectorAll('[data-recipe-video-card]').forEach(function (card) {
        card.addEventListener('click', function () {
          var caption = card.getAttribute('data-video-caption') || 'recipe_video';
          var videoSrc = card.getAttribute('data-video-src');
          var videoUrl = card.getAttribute('data-video-url');

          window.dispatchEvent(new CustomEvent('hb_navigation_click', {
            detail: {
              type: 'pdp_recipe_videos',
              name: 'recipe_video_play',
              click_text: caption,
              click_link: videoUrl || videoSrc || '/'
            }
          }));

          openRecipeVideoLightbox(card);
        });
      });
    });
  }

  var lastCalculateurPack = null;
  var lastCalculateurRationRaw = '';

  function parseKgFromOption(option1) {
    if (!option1) return null;
    var m = String(option1).replace(',', '.').match(/(\d+(?:\.\d+)?)\s*kg/i);
    if (m) return parseFloat(m[1]);
    var g = String(option1).replace(',', '.').match(/(\d+(?:\.\d+)?)\s*g\b/i);
    if (g) return parseFloat(g[1]) / 1000;
    return null;
  }

  function getVariantKg(v) {
    if (!v) return null;
    return parseKgFromOption(v.option1) || parseKgFromOption(v.option2) || parseKgFromOption(v.option3) || parseKgFromOption(v.title);
  }

  function isSampleVariant(v) {
    var blob = [v && v.title, v && v.option1, v && v.option2, v && v.option3].join(' ').toLowerCase();
    return blob.indexOf('échantillon') !== -1 || blob.indexOf('echantillon') !== -1;
  }

  function getSelectedPdpOptionValues() {
    var values = [];
    document.querySelectorAll('[data-pdp-revamp] .product__option-radio-buttons:not(.has-poids) input:checked').forEach(function (el) {
      if (el.value) values.push(el.value);
    });
    return values;
  }

  function variantOptionMatchCount(v, selectedValues) {
    if (!selectedValues || !selectedValues.length) return 0;
    var opts = [v.option1, v.option2, v.option3];
    var matches = 0;
    for (var i = 0; i < selectedValues.length; i++) {
      if (opts.indexOf(selectedValues[i]) !== -1) matches += 1;
    }
    return matches;
  }

  function formatKgLabel(kg) {
    if (kg == null || isNaN(kg)) return '';
    var n = Number(kg);
    if (Math.abs(n - Math.round(n)) < 0.05) return String(Math.round(n));
    return String(n).replace('.', ',');
  }

  function parseDailyGrams(rationRaw, isMixed) {
    var raw = String(rationRaw || '');
    if (isMixed || /\+/.test(raw)) {
      var first = raw.match(/(\d+(?:[.,]\d+)?)\s*g/i);
      if (first) return parseFloat(String(first[1]).replace(',', '.')) || 0;
    }
    var grams = parseInt(raw.replace(/[^\d]/g, ''), 10);
    return isNaN(grams) ? 0 : grams;
  }

  function recommendPack(variants, monthlyKg) {
    if (!variants || !variants.length || !monthlyKg) return null;
    var selected = getSelectedPdpOptionValues();
    var best = null;
    var bestDiff = Infinity;
    var bestMatch = -1;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.available || isSampleVariant(v)) continue;
      var kg = getVariantKg(v);
      if (!kg || kg <= 0) continue;
      var bags = monthlyKg / kg;
      var diff = Math.abs(bags - 1);
      var match = variantOptionMatchCount(v, selected);
      if (diff < bestDiff - 0.0001 || (Math.abs(diff - bestDiff) < 0.0001 && match > bestMatch)) {
        bestDiff = diff;
        bestMatch = match;
        best = { variant: v, kg: kg, bags: bags };
      }
    }
    return best;
  }

  function getCalculateurVariants() {
    var options = document.querySelectorAll('[data-pdp-revamp] [data-product-select] option, [data-calculateur-popup] select[name="id"] option, [data-pdp-revamp] select[name="id"] option');
    var variants = [];
    var seen = {};
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      if (!opt.value || seen[opt.value]) continue;
      seen[opt.value] = true;
      variants.push({
        id: opt.value,
        available: opt.getAttribute('data-variant-available') !== 'false',
        option1: opt.getAttribute('data-option-1') || '',
        option2: opt.getAttribute('data-option-2') || '',
        option3: opt.getAttribute('data-option-3') || '',
        title: (opt.textContent || '').trim()
      });
    }
    return variants;
  }

  function findPdpRadio(pdp, value) {
    if (!pdp || !value) return null;
    var radios = pdp.querySelectorAll('.product__option-radio-buttons:not(.has-poids) input');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) return radios[i];
    }
    var kg = parseKgFromOption(value);
    if (!kg) return null;
    for (var j = 0; j < radios.length; j++) {
      var radioKg = parseKgFromOption(radios[j].value);
      if (radioKg && Math.abs(radioKg - kg) < 0.05) return radios[j];
    }
    return null;
  }

  function selectPdpVariant(variant) {
    if (!variant || !variant.id) return false;
    var pdp = document.querySelector('[data-pdp-revamp]');
    if (!pdp) return false;

    var values = [variant.option1, variant.option2, variant.option3].filter(function (val) {
      return val && String(val).trim() && String(val) !== 'Default Title';
    });

    var lastGroup = null;
    for (var i = 0; i < values.length; i++) {
      var radio = findPdpRadio(pdp, values[i]);
      if (!radio || radio.disabled) continue;
      radio.checked = true;
      var group = radio.closest('.product__option-radio-buttons');
      if (group) {
        var select = group.querySelector('select');
        if (select) select.value = radio.value;
        lastGroup = group;
      }
    }

    var productSelect = pdp.querySelector('[data-product-select]') || document.querySelector('[data-product-select]');
    function applyProductSelect() {
      if (!productSelect) return;
      productSelect.value = String(variant.id);
      var selectedOpt = productSelect.querySelector('option[value="' + variant.id + '"]');
      if (selectedOpt) selectedOpt.selected = true;
    }

    applyProductSelect();
    if (lastGroup) {
      lastGroup.dispatchEvent(new Event('change', { bubbles: true }));
      applyProductSelect();
    }

    return true;
  }

  function getCalculateurRecommendedPack() {
    if (lastCalculateurPack && lastCalculateurPack.variant) return lastCalculateurPack;
    if (!lastCalculateurRationRaw) return null;
    var mixed = isCalculateurMixte() || /\+/.test(String(lastCalculateurRationRaw));
    var grams = parseDailyGrams(lastCalculateurRationRaw, mixed);
    var monthlyKg = (grams * 31) / 1000;
    return (!mixed || grams > 0) ? recommendPack(getCalculateurVariants(), monthlyKg) : null;
  }

  function restoreCalculateurOptionValues() {
    document.querySelectorAll('.calculateur-de-ration--revamp [data-calculateur-question] option').forEach(function (opt) {
      var attr = opt.getAttribute('value');
      if (attr == null || attr === '') return;
      opt.value = attr;
      opt.textContent = attr;
    });
  }

  function syncCalculateurResultPack(rationRaw) {
    lastCalculateurRationRaw = rationRaw || '';
    applyRationFromRaw(lastCalculateurRationRaw, isCalculateurMixte() || /\+/.test(String(rationRaw || '')));
    var root = document.querySelector('.calculateur-de-ration--revamp');
    if (!root) return;
    var textEl = root.querySelector('[data-calculateur-loaded-text-1]');
    var packEl = root.querySelector('[data-calculateur-result-pack]');
    var mixed = isCalculateurMixte() || /\+/.test(String(rationRaw || ''));
    var grams = parseDailyGrams(rationRaw, mixed);
    var monthlyKg = (grams * 31) / 1000;
    var monthlyLabel = formatKgLabel(Number(monthlyKg.toFixed(1)));
    if (String(monthlyLabel).slice(-2) === ',0') monthlyLabel = String(monthlyLabel).slice(0, -2);

    var rationLabel = String(rationRaw || '').replace(/\s*\/?jour\.?$/i, '').trim();
    if (textEl) {
      if (mixed) {
        textEl.textContent = rationLabel + '/jour.';
      } else {
        textEl.textContent = rationLabel + '/jour, soit une consommation de ' + monthlyLabel + ' kg/mois';
      }
    }

    var pack = (!mixed || grams > 0) ? recommendPack(getCalculateurVariants(), monthlyKg) : null;
    lastCalculateurPack = pack;
    if (!packEl) return;
    if (pack) {
      var bagsRounded = Math.max(1, Math.round(pack.bags));
      var packLabel = formatKgLabel(pack.kg).replace('.', ',');
      packEl.innerHTML =
        '= environ ' +
        bagsRounded +
        ' sac' +
        (bagsRounded > 1 ? 's' : '') +
        ' de<br>' +
        packLabel +
        ' kg par mois';
    } else {
      packEl.textContent = '';
    }
  }

  function initCalculateurRevampCopy() {
    if (!document.querySelector('[data-pdp-revamp]')) return;
    restoreCalculateurOptionValues();
    window.addEventListener('hb_feeding_guide_action', function (e) {
      if (!e.detail || e.detail.type !== 'generate' || !e.detail.result) return;
      syncCalculateurResultPack(e.detail.result);
      window.dispatchEvent(new CustomEvent('hb_navigation_click', {
        detail: {
          type: 'pdp_calculator',
          name: 'daily_calculator_generate',
          click_text: String(e.detail.result || 'generate'),
          click_link: '/'
        }
      }));
    });
  }

  function formatRationKg(kg) {
    if (kg == null || isNaN(kg)) return '';
    var n = Number(kg);
    if (Math.abs(n - Math.round(n)) < 0.05) return String(Math.round(n));
    var label = String(Number(n.toFixed(1))).replace('.', ',');
    if (label.slice(-2) === ',0') label = label.slice(0, -2);
    return label;
  }

  function isCalculateurMixte() {
    var root = document.querySelector('.calculateur-de-ration--revamp') || document;
    var selects = root.querySelectorAll('[data-calculateur-question]');
    for (var i = 0; i < selects.length; i++) {
      var val = String(selects[i].value || '').toLowerCase();
      if (val === 'mixte' || val.indexOf('mixte') !== -1) return true;
    }
    return false;
  }

  function isMixedAnswer(answers) {
    for (var i = 0; i < answers.length; i++) {
      var a = String(answers[i] || '').toLowerCase();
      if (a === 'mixte' || a.indexOf('mixte') !== -1) return true;
    }
    return false;
  }

  function matchRationResult(results, answers) {
    if (!results || !results.length || !answers || !answers.length) return null;
    for (var i = 0; i < results.length; i++) {
      var row = results[i];
      var ok = true;
      for (var a = 0; a < answers.length; a++) {
        var key = 'answer_' + (a + 1);
        if (row[key] == null || row[key] === '') continue;
        if (String(row[key]).trim().toLowerCase() !== String(answers[a]).trim().toLowerCase()) {
          ok = false;
          break;
        }
      }
      if (ok && row.result != null && row.result !== '') return row;
    }
    return null;
  }

  function escapeRationHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function getCalculateurResults() {
    var box = document.querySelector('.calculateur-de-ration--revamp [data-calculateur-results]') || document.querySelector('[data-calculateur-results]');
    if (!box) return [];
    var attr = box.getAttribute('data-calculateur-results');
    if (attr) {
      try {
        var parsed = JSON.parse(attr);
        if (parsed && parsed.length) return parsed;
      } catch (e) {}
    }
    if (window.jQuery) {
      var data = window.jQuery(box).data('calculateurResults');
      if (data && data.length) return data;
    }
    return [];
  }

  function readCalculateurAnswers() {
    var root = document.querySelector('.calculateur-de-ration--revamp') || document;
    var selects = root.querySelectorAll('[data-calculateur-question]');
    if (!selects.length) return null;
    var answers = [];
    for (var i = 0; i < selects.length; i++) {
      var val = selects[i].value;
      if (!val) return null;
      answers.push(val);
    }
    return answers;
  }

  function buildRationSummary(rationRaw, mixed) {
    var rationLabel = String(rationRaw || '').replace(/\s*\/?jour\.?$/i, '').trim();
    if (!rationLabel || /\$/.test(rationLabel)) return null;
    if (mixed || /\+/.test(rationLabel)) {
      return { prefix: 'Ration recommandée : ', value: rationLabel + ' / jour' };
    }
    var grams = parseDailyGrams(rationRaw, false);
    var monthlyLabel = formatRationKg((grams * 31) / 1000);
    if (!monthlyLabel) {
      return { prefix: 'Ration recommandée : ', value: rationLabel + ' / jour' };
    }
    return { prefix: 'Ration recommandée : ', value: monthlyLabel + ' kg / mois' };
  }

  var PDP_RATION_STORAGE_KEY = 'franklin-pdp-ration';
  var lastCalculateurRationSummary = null;

  function rationLinkNodes() {
    return document.querySelectorAll(
      '[data-pdp-ration-label], [data-pdp-revamp] [data-open-calculateur], .guide-block--revamp[data-open-calculateur]'
    );
  }

  function applyRationSummaryToPage(summary) {
    if (!summary || !summary.value) return;
    lastCalculateurRationSummary = summary;
    var html =
      escapeRationHtml(summary.prefix || 'Ration recommandée : ') +
      '<span class="product-ration-value">' +
      escapeRationHtml(summary.value) +
      '</span>';
    document.querySelectorAll('[data-pdp-ration-label]').forEach(function (node) {
      node.innerHTML = html;
      var btn = node.closest('[data-open-calculateur]');
      if (btn && btn.classList) btn.classList.add('is-ration-set');
    });
    document.querySelectorAll('[data-pdp-revamp] [data-open-calculateur], .guide-block--revamp[data-open-calculateur]').forEach(function (btn) {
      if (btn.classList) btn.classList.add('is-ration-set');
      if (btn.querySelector('[data-pdp-ration-label]')) return;
      var container = btn.querySelector('.guide-block__container');
      if (container) {
        container.innerHTML = '<p data-pdp-ration-label>' + html + '</p>';
      }
    });
  }

  function persistRationSummary(rationRaw, summary) {
    try {
      sessionStorage.setItem(PDP_RATION_STORAGE_KEY, JSON.stringify({
        path: location.pathname,
        ration: String(rationRaw || ''),
        summary: summary
      }));
    } catch (e) {}
  }

  function applyRationFromRaw(rationRaw, mixed) {
    var raw = String(rationRaw || '').trim();
    if (!raw || /\$/.test(raw)) return;
    lastCalculateurRationRaw = raw;
    var summary = buildRationSummary(raw, !!mixed);
    if (!summary) return;
    applyRationSummaryToPage(summary);
    persistRationSummary(raw, summary);
  }

  function syncRationFromQuestions() {
    var answers = readCalculateurAnswers();
    if (!answers) return;
    var match = matchRationResult(getCalculateurResults(), answers);
    if (!match || !match.result) return;
    var mixed = isMixedAnswer(answers) || /\+/.test(String(match.result));
    applyRationFromRaw(match.result, mixed);
  }

  function restoreRationToPage() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(PDP_RATION_STORAGE_KEY) || 'null');
      if (!saved || saved.path !== location.pathname) return;
      if (saved.summary && saved.summary.value) {
        lastCalculateurRationRaw = saved.ration || '';
        applyRationSummaryToPage(saved.summary);
        return;
      }
      if (saved.ration) applyRationFromRaw(saved.ration, /\+/.test(String(saved.ration)));
    } catch (e) {}
  }

  function extractRationFromLoadedText(text) {
    var m = String(text || '').match(/(\d+(?:[.,]\d+)?\s*g(?:\s*\+\s*\d+(?:[.,]\d+)?\s*g)?)/i);
    return m ? m[1].replace(/\s+/g, '') : '';
  }

  function watchCalculateurLoadedBox() {
    var box = document.querySelector('.calculateur-de-ration--revamp [data-calculateur-loaded-1], [data-calculateur-loaded-1]');
    if (!box || box.getAttribute('data-pdp-ration-watched')) return;
    box.setAttribute('data-pdp-ration-watched', 'true');
    var applyFromDom = function () {
      if (box.classList.contains('hide')) return;
      var textEl = box.querySelector('[data-calculateur-loaded-text-1]');
      var extracted = extractRationFromLoadedText(textEl && textEl.textContent);
      if (extracted) {
        applyRationFromRaw(extracted, isCalculateurMixte() || /\+/.test(extracted));
        return;
      }
      syncRationFromQuestions();
    };
    var observer = new MutationObserver(applyFromDom);
    observer.observe(box, { attributes: true, childList: true, subtree: true, characterData: true });
  }

  function initCalculateurRationLabel() {
    if (!document.querySelector('[data-pdp-revamp]')) return;

    restoreRationToPage();
    syncRationFromQuestions();
    watchCalculateurLoadedBox();

    var questionRoot = document.querySelector('.calculateur-de-ration--revamp') || document;
    questionRoot.querySelectorAll('[data-calculateur-question]').forEach(function (sel) {
      sel.addEventListener('change', syncRationFromQuestions);
    });
    document.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('[data-calculateur-question]')) return;
      syncRationFromQuestions();
    });
    if (window.jQuery) {
      window.jQuery(document).on('change', '[data-calculateur-question]', syncRationFromQuestions);
    }

    window.addEventListener('hb_feeding_guide_action', function (e) {
      if (!e.detail || e.detail.type !== 'generate' || !e.detail.result) return;
      applyRationFromRaw(e.detail.result, isCalculateurMixte() || /\+/.test(String(e.detail.result)));
      window.setTimeout(function () {
        applyRationFromRaw(e.detail.result, isCalculateurMixte() || /\+/.test(String(e.detail.result)));
      }, 1100);
    });
    window.addEventListener('openPopupCalculateur', function () {
      watchCalculateurLoadedBox();
      window.setTimeout(syncRationFromQuestions, 50);
    });

    document.addEventListener('click', function (e) {
      var target = e.target && e.target.closest ? e.target.closest('[data-close-calculateur]') : null;
      if (!target) return;
      try {
        if (lastCalculateurRationSummary) applyRationSummaryToPage(lastCalculateurRationSummary);
        else if (lastCalculateurRationRaw) applyRationFromRaw(lastCalculateurRationRaw, isCalculateurMixte() || /\+/.test(lastCalculateurRationRaw));
        else syncRationFromQuestions();
      } catch (err) {}
    }, true);

    rationLinkNodes().forEach(function (btn) {
      var clickTarget = btn.hasAttribute('data-open-calculateur') ? btn : btn.closest('[data-open-calculateur]');
      if (!clickTarget || clickTarget.getAttribute('data-pdp-ration-click')) return;
      clickTarget.setAttribute('data-pdp-ration-click', 'true');
      clickTarget.addEventListener('click', function () {
        window.dispatchEvent(new CustomEvent('hb_navigation_click', {
          detail: {
            type: 'pdp_calculator',
            name: 'daily_calculator_open',
            click_text: (clickTarget.textContent || 'calculator').replace(/\s+/g, ' ').trim(),
            click_link: '/'
          }
        }));
      });
    });
  }

  function applyCalculateurDiscount(code) {
    if (!code) return Promise.resolve();

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var alreadyApplied = codes.some(function (entry) {
          return entry && String(entry.code).toLowerCase() === code.toLowerCase();
        });
        if (alreadyApplied) return;

        return fetch('/discount/' + encodeURIComponent(code), {
          credentials: 'same-origin'
        });
      })
      .catch(function () {});
  }

  function selectSubscriptionForCalculateur() {
    var subInput = document.querySelector('#product-buy-section input[name="buy-options"][value="subscription"]');
    var oneTimeInput = document.querySelector('#product-buy-section input[name="buy-options"][value="one-time"]');
    if (!subInput) return;

    subInput.checked = true;
    if (oneTimeInput) oneTimeInput.checked = false;
    subInput.dispatchEvent(new Event('change', { bubbles: true }));

    var buyButtons = document.querySelector('buy-buttons-container');
    if (buyButtons && typeof buyButtons.syncPurchaseOption === 'function') {
      buyButtons.syncPurchaseOption();
    }
    syncPurchasePrices();
  }

  var FREQ_ITEM_HEIGHT = 44;
  var FREQ_FALLBACK = [25, 30, 35, 40, 45, 50, 60, 70, 90, 120];
  var FREQ_STORAGE_KEY = 'franklin_subscription_lp_frequency';

  function labelForFrequency(n) {
    return n > 1 ? 'Tous les ' + n + ' jours' : 'Tous les ' + n + ' jour';
  }

  function readLockedFrequency() {
    try {
      var stored = sessionStorage.getItem(FREQ_STORAGE_KEY);
      if (stored) {
        var n = Number(stored);
        if (!isNaN(n) && n > 0) return n;
      }
    } catch (e) {}
    return null;
  }

  function writeLockedFrequency(freq) {
    try {
      sessionStorage.setItem(FREQ_STORAGE_KEY, String(freq));
    } catch (e) {}
  }

  function getBuyboxFrequencies() {
    var freq = document.querySelector('#frequence') || document.querySelector('[data-pdp-revamp] [data-frequency-selector]');
    if (!freq) return FREQ_FALLBACK.slice();
    var values = [];
    for (var i = 0; i < freq.options.length; i++) {
      var n = Number(String(freq.options[i].value).replace(/[^\d]/g, ''));
      if (!isNaN(n) && n > 0) values.push(n);
    }
    return values.length ? values : FREQ_FALLBACK.slice();
  }

  function applyFrequencyToBuybox(days) {
    var ok = false;
    document.querySelectorAll('#frequence, [data-pdp-revamp] [data-frequency-selector]').forEach(function (freq) {
      var match = null;
      for (var i = 0; i < freq.options.length; i++) {
        if (Number(String(freq.options[i].value).replace(/[^\d]/g, '')) === Number(days)) {
          match = freq.options[i];
          break;
        }
      }
      if (!match) return;
      freq.value = match.value;
      if (window.jQuery) window.jQuery(freq).val(match.value).trigger('change');
      else freq.dispatchEvent(new Event('change', { bubbles: true }));
      ok = true;
    });
    clearFrequencyError();
    return ok;
  }

  function resolveCalculateurFrequency() {
    var freqs = getBuyboxFrequencies();
    var buybox = document.querySelector('#frequence');
    var current = buybox ? Number(String(buybox.value).replace(/[^\d]/g, '')) : NaN;
    if (!isNaN(current) && current > 0 && freqs.indexOf(current) !== -1) return current;
    var locked = readLockedFrequency();
    if (locked && freqs.indexOf(Number(locked)) !== -1) return Number(locked);
    if (freqs.indexOf(30) !== -1) return 30;
    return freqs[0] || 30;
  }

  function getSelectedVariantId() {
    var pack = getCalculateurRecommendedPack();
    if (pack && pack.variant && pack.variant.id) return String(pack.variant.id);
    var select = document.querySelector('[data-pdp-revamp] [data-product-select], [data-pdp-revamp] select[name="id"]');
    if (select && select.value && select.value !== 'label') return String(select.value);
    return null;
  }

  function getCalculateurSellingPlans() {
    var script = document.querySelector('[data-calculateur-selling-plans]');
    if (script) {
      try {
        var parsed = JSON.parse(script.textContent);
        if (parsed && parsed.length) return parsed;
      } catch (e) {}
    }
    var plans = [];
    document.querySelectorAll('#frequence option[selling_plan_id], [data-frequency-selector] option[selling_plan_id]').forEach(function (opt) {
      var freq = Number(String(opt.value).replace(/[^\d]/g, ''));
      var id = opt.getAttribute('selling_plan_id');
      if (!isNaN(freq) && freq > 0 && id) plans.push({ frequency: freq, id: id });
    });
    return plans;
  }

  function getSellingPlanIdForFrequency(days) {
    var plans = getCalculateurSellingPlans();
    for (var i = 0; i < plans.length; i++) {
      if (Number(plans[i].frequency) === Number(days)) return plans[i].id;
    }
    return plans[0] && plans[0].id ? plans[0].id : null;
  }

  function closeCalculateurPopup() {
    var popup = document.querySelector('[data-calculateur-popup]');
    if (popup) {
      popup.style.display = 'none';
      popup.setAttribute('hidden', '');
    }
    document.querySelectorAll('.quickview.calculateur-overlay, .calculateur-overlay').forEach(function (el) {
      el.style.display = 'none';
    });
    document.body.classList.remove('non-scroll');
    if (window.jQuery) window.jQuery('[data-calculateur-popup]').hide();
  }

  function getPdpSubscribeAtc() {
    return document.querySelector('[data-pdp-revamp] button.product-subscription-link[data-subscription-activate], [data-pdp-revamp] .product-subscription-link[data-subscription-activate]');
  }

  function addCalculateurSubscription(days, promoCode) {
    var pack = getCalculateurRecommendedPack();
    if (pack) selectPdpVariant(pack.variant);

    applyFrequencyToBuybox(days);
    selectSubscriptionForCalculateur();
    writeLockedFrequency(days);

    var variantId = getSelectedVariantId();
    var sellingPlanId = getSellingPlanIdForFrequency(days);
    var atc = getPdpSubscribeAtc();
    if (atc) atc.classList.remove('hidden');

    function finish() {
      closeCalculateurPopup();
      applyCalculateurDiscount(promoCode);
      if (typeof window.openCart === 'function') window.openCart();
    }

    if (variantId && sellingPlanId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1,
            selling_plan: sellingPlanId,
            properties: {
              _shipping_interval_frequency: String(days),
              _shipping_interval_unit_type: 'Days'
            }
          }]
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add failed');
        return r.json();
      }).then(function () {
        finish();
      }).catch(function () {
        if (atc) atc.click();
        else closeCalculateurPopup();
      });
      return;
    }

    if (atc) {
      window.setTimeout(function () {
        applyFrequencyToBuybox(days);
        atc.click();
        finish();
      }, 60);
      return;
    }

    closeCalculateurPopup();
  }

  var FrequencyModal = {
    el: null,
    scrollEl: null,
    selected: 30,
    options: FREQ_FALLBACK.slice(),
    pending: null,
    scrollTimer: null,

    ensure: function () {
      if (this.el) return;
      var root = document.createElement('div');
      root.className = 'subscription-freq-modal';
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.setAttribute('aria-labelledby', 'subscription-freq-modal-title');
      root.innerHTML =
        '<button type="button" class="subscription-freq-modal__backdrop" aria-label="Fermer"></button>' +
        '<div class="subscription-freq-modal__panel">' +
        '  <button type="button" class="subscription-freq-modal__close" aria-label="Fermer">×</button>' +
        '  <h2 id="subscription-freq-modal-title" class="subscription-freq-modal__title">Choisissez votre fréquence</h2>' +
        '  <div class="subscription-freq-modal__wheel-wrap">' +
        '    <div class="subscription-freq-wheel" role="listbox" aria-label="Fréquence de commande">' +
        '      <div class="subscription-freq-wheel__fade subscription-freq-wheel__fade--top" aria-hidden="true"></div>' +
        '      <div class="subscription-freq-wheel__fade subscription-freq-wheel__fade--bottom" aria-hidden="true"></div>' +
        '      <div class="subscription-freq-wheel__rail" aria-hidden="true"></div>' +
        '      <div class="subscription-freq-wheel__scroll"></div>' +
        '    </div>' +
        '  </div>' +
        '  <button type="button" class="subscription-freq-modal__confirm">JE VALIDE</button>' +
        '  <p class="subscription-freq-modal__footnote">Une seule fréquence possible pour tous vos produits en abonnement</p>' +
        '</div>';
      document.body.appendChild(root);
      this.el = root;
      this.scrollEl = root.querySelector('.subscription-freq-wheel__scroll');

      var self = this;
      root.querySelector('.subscription-freq-modal__backdrop').addEventListener('click', function () {
        self.close();
      });
      root.querySelector('.subscription-freq-modal__close').addEventListener('click', function () {
        self.close();
      });
      root.querySelector('.subscription-freq-modal__confirm').addEventListener('click', function () {
        self.confirm();
      });
      this.scrollEl.addEventListener('scroll', function () {
        if (self.scrollTimer) window.clearTimeout(self.scrollTimer);
        self.scrollTimer = window.setTimeout(function () {
          self.scrollTimer = null;
          self.syncFromScroll();
        }, 120);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });
    },

    renderOptions: function () {
      var self = this;
      this.scrollEl.innerHTML = '';
      this.options.forEach(function (n) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'subscription-freq-wheel__item' + (n === self.selected ? ' is-active' : '');
        btn.setAttribute('role', 'option');
        btn.setAttribute('aria-selected', n === self.selected ? 'true' : 'false');
        btn.dataset.frequency = String(n);
        btn.textContent = labelForFrequency(n);
        btn.addEventListener('click', function () {
          self.setSelected(n, true);
        });
        self.scrollEl.appendChild(btn);
      });
    },

    setSelected: function (n, scroll) {
      this.selected = n;
      var items = this.scrollEl.querySelectorAll('.subscription-freq-wheel__item');
      for (var i = 0; i < items.length; i++) {
        var active = Number(items[i].dataset.frequency) === n;
        items[i].classList.toggle('is-active', active);
        items[i].setAttribute('aria-selected', active ? 'true' : 'false');
      }
      if (scroll) {
        var idx = this.options.indexOf(n);
        if (idx >= 0) {
          this.scrollEl.scrollTo({ top: idx * FREQ_ITEM_HEIGHT, behavior: 'smooth' });
        }
      }
    },

    syncFromScroll: function () {
      if (!this.options.length) return;
      var idx = Math.round(this.scrollEl.scrollTop / FREQ_ITEM_HEIGHT);
      idx = Math.max(0, Math.min(this.options.length - 1, idx));
      var next = this.options[idx];
      if (next !== undefined && next !== this.selected) {
        this.setSelected(next, false);
      }
    },

    open: function (options, defaultFreq, pending) {
      this.ensure();
      var sorted = (options && options.length ? options.slice() : FREQ_FALLBACK.slice())
        .map(Number)
        .filter(function (n) {
          return !isNaN(n) && n > 0;
        })
        .sort(function (a, b) {
          return a - b;
        });
      this.options = sorted.filter(function (n, i, arr) {
        return arr.indexOf(n) === i;
      });
      var preferred = Number(defaultFreq) || 30;
      if (this.options.indexOf(preferred) === -1) {
        preferred = this.options[Math.floor(this.options.length / 2)] || this.options[0];
      }
      this.selected = preferred;
      this.pending = pending;
      this.renderOptions();
      this.el.classList.add('is-open');
      document.body.classList.add('subscription-freq-modal-open');
      var self = this;
      requestAnimationFrame(function () {
        var idx = self.options.indexOf(self.selected);
        if (idx >= 0) self.scrollEl.scrollTop = idx * FREQ_ITEM_HEIGHT;
      });
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.body.classList.remove('subscription-freq-modal-open');
      this.pending = null;
      var confirmBtn = this.el.querySelector('.subscription-freq-modal__confirm');
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.textContent = 'JE VALIDE';
      }
    },

    confirm: function () {
      if (!this.pending) return;
      var confirmBtn = this.el.querySelector('.subscription-freq-modal__confirm');
      if (confirmBtn) {
        confirmBtn.disabled = true;
        confirmBtn.textContent = '…';
      }
      var days = this.selected;
      var pending = this.pending;
      this.pending = null;
      if (typeof pending.onConfirm === 'function') {
        pending.onConfirm(days);
      } else {
        addCalculateurSubscription(days, pending.promoCode);
      }
      this.close();
    }
  };

  function applyCalculateurRecommendationToPage() {
    if (lastCalculateurRationRaw) {
      applyRationFromRaw(lastCalculateurRationRaw, isCalculateurMixte() || /\+/.test(String(lastCalculateurRationRaw)));
    } else {
      syncRationFromQuestions();
      var textEl = document.querySelector('[data-calculateur-loaded-1]:not(.hide) [data-calculateur-loaded-text-1], [data-calculateur-loaded-text-1]');
      var extracted = extractRationFromLoadedText(textEl && textEl.textContent);
      if (extracted) applyRationFromRaw(extracted, isCalculateurMixte() || /\+/.test(extracted));
    }
    if (lastCalculateurRationSummary) applyRationSummaryToPage(lastCalculateurRationSummary);
    var pack = getCalculateurRecommendedPack();
    if (pack) selectPdpVariant(pack.variant);
    selectSubscriptionForCalculateur();
  }

  function handleCalculateurSubscribe(promoCode) {
    applyCalculateurRecommendationToPage();
    closeCalculateurPopup();
    FrequencyModal.open(getBuyboxFrequencies(), 30, { promoCode: promoCode });
  }

  function onCalculateurSubscribeClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-calculateur-revamp-subscribe]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    if (btn.getAttribute('data-busy') === 'true') return;
    btn.setAttribute('data-busy', 'true');

    window.dispatchEvent(new CustomEvent('hb_navigation_click', {
      detail: {
        type: 'pdp_calculator',
        name: 'daily_calculator_subscribe',
        click_text: (btn.textContent || 'JE M\'ABONNE').trim(),
        click_link: '/'
      }
    }));

    var promoCode = (btn.getAttribute('data-promo-code') || 'ABO10').trim();
    try {
      handleCalculateurSubscribe(promoCode);
    } catch (err) {
      closeCalculateurPopup();
      FrequencyModal.open(getBuyboxFrequencies(), 30, { promoCode: promoCode });
    }
    window.setTimeout(function () {
      btn.removeAttribute('data-busy');
    }, 2000);
  }

  function initCalculateurSubscribeCta() {
    if (!document.querySelector('[data-pdp-revamp]')) return;

    syncCalculateurSubscribeCta();
    window.addEventListener('openPopupCalculateur', syncCalculateurSubscribeCta);
    window.addEventListener('hb_feeding_guide_action', function (e) {
      if (e.detail && e.detail.type === 'generate') syncCalculateurSubscribeCta();
    });

    document.addEventListener('click', onCalculateurSubscribeClick, true);
  }

  /* Mobile sticky ATC — mirrors the buybox AJOUTER CTA */

  function isStickyTargetVisible(el) {
    if (!el) return false;
    if (el.classList.contains('hidden') || el.classList.contains('hide')) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function getCartSubscriptionFrequency() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          var freq = item.properties && item.properties._shipping_interval_frequency;
          var isSubscription = !!item.selling_plan_allocation || !!freq;
          if (isSubscription && freq) {
            var n = Number(String(freq).replace(/[^\d]/g, ''));
            if (!isNaN(n) && n > 0) return n;
          }
        }
        return null;
      })
      .catch(function () { return null; });
  }

  function triggerSubscriptionAddWithFrequency(days) {
    var subscription = getPdpSubscribeAtc();
    if (!subscription) return;
    if (days) applyFrequencyToBuybox(days);
    window.setTimeout(function () {
      subscription.click();
    }, 60);
  }

  function onStickyAtcClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-sticky-add-to-cart]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('data-busy') === 'true') return;
    btn.setAttribute('data-busy', 'true');
    window.setTimeout(function () {
      btn.removeAttribute('data-busy');
    }, 1500);

    window.dispatchEvent(new CustomEvent('hb_navigation_click', {
      detail: {
        type: 'pdp_sticky_bar',
        name: 'sticky_add_to_cart',
        click_text: (btn.textContent || '').trim(),
        click_link: '/'
      }
    }));

    var root = document.querySelector('[data-pdp-revamp]');
    if (!root) return;

    var blocked = root.querySelector('[data-new-customer-only-error]');
    if (isStickyTargetVisible(blocked)) {
      blocked.click();
      return;
    }

    var subscription = getPdpSubscribeAtc();
    var oneTime = root.querySelector('button[data-add-to-cart]');
    var subscriptionMode = isStickyTargetVisible(subscription);
    if (!subscriptionMode && subscription) {
      var checked = document.querySelector('#product-buy-section input[name="buy-options"]:checked');
      subscriptionMode = !!(checked && checked.value === 'subscription');
    }

    if (!subscriptionMode) {
      if (oneTime) oneTime.click();
      return;
    }

    getCartSubscriptionFrequency().then(function (cartDays) {
      // Subscription already in cart: reuse its frequency silently
      if (cartDays && applyFrequencyToBuybox(cartDays)) {
        window.setTimeout(function () {
          subscription.click();
        }, 60);
        return;
      }

      // No subscription in cart: ask for the frequency, then add
      var freqs = getBuyboxFrequencies();
      var buybox = document.querySelector('#frequence');
      var current = buybox ? Number(String(buybox.value).replace(/[^\d]/g, '')) : NaN;
      var preferred = !isNaN(current) && current > 0 ? current : 30;
      FrequencyModal.open(freqs, preferred, {
        onConfirm: function (selectedDays) {
          triggerSubscriptionAddWithFrequency(selectedDays);
        }
      });
    });
  }

  function initStickyAtc() {
    if (!document.querySelector('[data-pdp-revamp]')) return;
    document.addEventListener('click', onStickyAtcClick, true);
  }

  function bootPdpRevamp() {
    if (bootPdpRevamp.done) return;
    bootPdpRevamp.done = true;
    [
      initLirePlus,
      initMarketingPushTracking,
      initProblematiqueAccordion,
      initCompositionAccordion,
      initIngredientsBenefits,
      initGalleryVideos,
      initUgcNav,
      stripFaqQuestionNumbers,
      initRecipeVideos,
      initCrossSell,
      initPurchaseOptionTracking,
      initFrequencyValidation,
      initAtcComparePrice,
      initCalculateurRationLabel,
      initCalculateurRevampCopy,
      initCalculateurSubscribeCta,
      initStickyAtc
    ].forEach(function (fn) {
      try {
        fn();
      } catch (err) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPdpRevamp);
  } else {
    bootPdpRevamp();
  }
})(); 

